/**
 * Default privacy defines the initial privacy status assigned to new members when they join a site.
 * This setting determines whether new members start with public or private profiles by default.
 */
export interface DefaultPrivacy {
  /**
   * Privacy ID.
   * @format GUID
   * @readonly
   */
  id?: string | null;
  /** Default privacy status for a new member. */
  defaultPrivacy?: PrivacyWithLiterals;
  /** Revision number, which increments by 1 each time the default privacy is updated. To prevent conflicting changes, the existing revision must be used when updating default privacy. */
  revision?: string | null;
}

export enum Privacy {
  /** Default privacy status is private. All members have private profiles with no option to make them public. */
  PRIVATE = 'PRIVATE',
  /** Default privacy status is public. All members can make their profile public. */
  PUBLIC = 'PUBLIC',
}

/** @enumType */
export type PrivacyWithLiterals = Privacy | 'PRIVATE' | 'PUBLIC';

export interface GetDefaultPrivacyStatusRequest {}

export interface GetDefaultPrivacyStatusResponse {
  /** Retrieved default privacy settings. */
  defaultPrivacy?: DefaultPrivacy;
}

export interface SetDefaultPrivacyStatusRequest {
  /** Default privacy settings to set. */
  defaultPrivacy: DefaultPrivacy;
}

export interface SetDefaultPrivacyStatusResponse {
  /** Default privacy settings. */
  defaultPrivacy?: DefaultPrivacy;
}
